import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, Input,
  Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Product } from "../../../classes/product";
import { ProductService } from '../../../../shared/services/product.service';
import { GlobalobjectsService } from 'src/app/globalobjects.service';
import { LoginService } from 'src/app/mylogin/loginc/login.service';

// Import JsBarcode with fallback
declare var JsBarcode: any;

@Component({
  selector: 'app-quick-view',
  templateUrl: './quick-view.component.html',
  styleUrls: ['./quick-view.component.scss']
})
export class QuickViewComponent implements OnInit, OnDestroy  {

  @Input() product: Product;
  @Input() currency: any;  
  @ViewChild("quickView", { static: false }) QuickView: TemplateRef<any>;

  public closeResult: string;
  public ImageSrc: string;
  public counter: number = 1;
  public modalOpen: boolean = false;
  public productattributes: any;
  public upcValue: string = null;
  public barcodeImageSrc: string = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private router: Router, private modalService: NgbModal,
    public productService: ProductService,public Globalobjects:GlobalobjectsService , 
    public LoginService:LoginService) { }

  ngOnInit(): void {
    
    this.ImageSrc = this.Globalobjects.ImageURL + this.product.images[0].src;
  }

  itemattributes(itemid:any) {

    const data = {
      
        "countryList_Id": localStorage.getItem('country'),
        "itemNumbers": [
          itemid
        ]
       
      }
      
    this.LoginService.GetItmesAtt(data).subscribe((response:any) => {
      this.productattributes = response.data2[0].attributes.sort((a, b) => a.displayOrder - b.displayOrder);
      
      // Check for UPC attribute
      this.checkForUPC();
    })

  }

  openModal(itemid:any) {
    this.itemattributes(itemid);
    this.modalOpen = true;
    
    // Update ImageSrc when modal opens (for dynamic product updates)
    if (this.product && this.product.images && this.product.images[0]) {
      this.ImageSrc = this.Globalobjects.ImageURL + this.product.images[0].src;
    }

    if (isPlatformBrowser(this.platformId)) { // For SSR 
      this.modalService.open(this.QuickView, { 
        size: 'lg',
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'Quickview' 
      }).result.then((result) => {
        `Result ${result}`
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // Get Product Color
  Color(variants) {
    const uniqColor = []
    for (let i = 0; i < Object.keys(variants).length; i++) {
      if (uniqColor.indexOf(variants[i].color) === -1 && variants[i].color) {
        uniqColor.push(variants[i].color)
      }
    }
    return uniqColor
  }

  // Get Product Size
  Size(variants) {
    const uniqSize = []
    for (let i = 0; i < Object.keys(variants).length; i++) {
      if (uniqSize.indexOf(variants[i].size) === -1 && variants[i].size) {
        uniqSize.push(variants[i].size)
      }
    }
    return uniqSize
  }

  // Change Variants
  ChangeVariants(color, product) {
    product.variants.map((item) => {
      if (item.color === color) {
        product.images.map((img) => {
          if (img.image_id === item.image_id) {
            this.ImageSrc = img.src
          }
        })
      }
    })
  }

  // Increament
  increment() {
    this.counter++ ;
  }

  // Decrement
  decrement() {
    if (this.counter > 1) this.counter-- ;
  }

  // Add to cart
  async addToCart(product: any) {
    product.quantity = this.counter || 1;
    const status = await this.productService.addToCart(product);
    if(status)
      this.router.navigate(['/shop/cart']);
  }

  // Check for UPC attribute in product attributes
  checkForUPC(): void {
    if (this.productattributes && this.productattributes.length > 0) {
      const upcAttribute = this.productattributes.find(attr => 
        attr.attributeName && attr.attributeName.toUpperCase() === 'UPC'
      );
      
      if (upcAttribute && upcAttribute.attributeValue) {
        this.upcValue = upcAttribute.attributeValue;
        
        // Generate barcode image immediately using the new method
        this.generateBarcodeImage();
      } else {
        this.upcValue = null;
        this.barcodeImageSrc = null;
      }
    }
  }

  // Generate barcode as image (canvas-free method)
  generateBarcodeImage(): void {
    if (!this.upcValue) {
      this.barcodeImageSrc = null;
      return;
    }

    // Check if JsBarcode is available
    if (typeof JsBarcode === 'undefined') {
      this.barcodeImageSrc = null;
      return;
    }

    try {
      // Create a temporary canvas element in memory
      const canvas = document.createElement('canvas');
      canvas.width = 300;
      canvas.height = 120;
      
      JsBarcode(canvas, this.upcValue, {
        format: "CODE128",
        width: 2,
        height: 80,
        displayValue: true,
        font: "Arial",
        textAlign: "center",
        textPosition: "bottom",
        textMargin: 2,
        fontSize: 14,
        background: "#ffffff",
        lineColor: "#000000",
        margin: 10
      });
      
      // Convert canvas to data URL
      this.barcodeImageSrc = canvas.toDataURL('image/png');
    } catch (error) {
      // Fallback: try with a simpler format
      try {
        const canvas = document.createElement('canvas');
        canvas.width = 300;
        canvas.height = 120;
        
        JsBarcode(canvas, this.upcValue, {
          format: "CODE39",
          displayValue: true,
          background: "#ffffff",
          lineColor: "#000000"
        });
        
        this.barcodeImageSrc = canvas.toDataURL('image/png');
      } catch (fallbackError) {
        this.barcodeImageSrc = null;
        
        // Final fallback: create a simple text image
        this.createTextBarcodeImage();
      }
    }
  }

  // Create a simple text-based barcode image as fallback
  createTextBarcodeImage(): void {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 300;
      canvas.height = 120;
      const ctx = canvas.getContext('2d');
      
      if (ctx) {
        // Clear canvas with white background
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Add border
        ctx.strokeStyle = '#cccccc';
        ctx.strokeRect(0, 0, canvas.width, canvas.height);
        
        // Add text
        ctx.fillStyle = '#000000';
        ctx.font = '16px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('Barcode Generation Failed', canvas.width / 2, canvas.height / 2 - 20);
        ctx.fillText(`UPC: ${this.upcValue}`, canvas.width / 2, canvas.height / 2);
        ctx.font = '12px Arial';
        ctx.fillText('Please try again or contact support', canvas.width / 2, canvas.height / 2 + 20);
        
        this.barcodeImageSrc = canvas.toDataURL('image/png');
      }
    } catch (error) {
      this.barcodeImageSrc = null;
    }
  }

  ngOnDestroy() {
    if(this.modalOpen){
      this.modalService.dismissAll();
    }
  }

}
